<template>
  <div class="blog">
      <Loader v-if="loader == true"  />
      <div 
            class="main_block_loader"
            v-else
       >
            <div class="blog_header">
                <h1>Полезные статьи</h1>
            </div>
            <div class="blog_content">
                <div 
                    class="blog_content_block"
                    v-for="blog in blogs"
                    :key="blog.id" 
                    @click="openBlog(blog.id)"
                >
                        <div class="blog_content_block_img">
                            <img :src="'https://ecodom04.com/backend/'+blog.img" alt="">
                        </div>
                        <div class="blog_content_block_text" id="blog_content_block_text_scroll">
                            <p>
                                {{blog.name}}
                            </p>
                        </div>
                        <button>Просмотреть</button>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'blogs',
  components: {
      Loader
  },
  data () {
      return {
         blogs: [],
         loader: true
      }
  },
  methods: {
     getBlogs() {
        fetch(this.$apiURI + 'public/blogs/getall')
        .then((res) => {
            res.json().then((data) => {
                this.blogs = data
                this.loader = false
            });
        })
    },
    openBlog(id) {
        this.$router.push({ name: 'Blog', params: { id: id }})
    },
  },
  mounted() {
      this.getBlogs()
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.blog {
    width: 1200px;
    margin: 0 auto;
    background: white;
     @media (max-width: @baseMedia) {
        width: 95%;
    }
    .main_block_loader {
        width: 100%;
         .blog_header {
            padding-top: 20px;
            padding-bottom: 20px;
            text-align: center;
            @media (max-width: @baseMedia) {
                padding-top: 10px;
                padding-bottom: 10px;
            }
            h1 {
                color: #4a4a4a;
                font-size: 30px;
                @media (max-width: @baseMedia) {
                    font-size: 20px;
                }
            }
        }
        .blog_content {
            width: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            @media (max-width: @baseMedia) {
                justify-content: center;
            }
            .blog_content_block {
                width: 280px;
                border: 1px solid #ccc;
                padding: 5px;
                margin: 10px;
                &:hover {
                    box-shadow: 0px 0px 2px 0px rgb(102, 136, 0);
                }
                button {
                    width: 100%;
                    background: #668800;
                    height: 30px;
                    margin-top: 10px;
                    text-transform: uppercase;
                    font-size: 15px;
                    color: #fff;
                    &:hover {
                        opacity: 0.7;
                    }
                }
                .blog_content_block_img {
                    width: 100%;
                    height: 200px;
                    overflow: hidden;
                    cursor: pointer;
                    img {
                        width: 100%;
                        height: 100%;
                        &:hover {
                            transition: 2s;
                            width: 110%;
                            height: 110%;
                        }
                    }
                }
                #blog_content_block_text_scroll::-webkit-scrollbar-track
                {
                    border-radius: 5px;
                    background-color: #fff;
                }

                #blog_content_block_text_scroll::-webkit-scrollbar
                {
                    width: 10px;
                }

                #blog_content_block_text_scroll::-webkit-scrollbar-thumb
                {
                    border-radius: 5px;
                    background-color: #680;
                }
                .blog_content_block_text {
                    width: 100%;
                    height: 30px;
                    text-align: center;
                    overflow-y: scroll;
                    margin-top: 10px;
                    p {
                        font-weight: bold;
                        font-size: 18px;
                    }
                }
            }
        }
    }
   
}
</style>